const S = {
    page: {
        background: "#f8fafc",
        // minHeight: "100vh",
        padding: "24px",
        fontFamily: "'Inter', system-ui, sans-serif",
    },
    topBar: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginBottom: "12px",
        flexWrap: "wrap",
    },
    pageTitle: {
        fontSize: "20px",
        fontWeight: 600,
        color: "#0f172a",
        flex: "1 1 160px",
        margin: 0,
    },
    searchWrap: {
        position: "relative",
        flex: "1 1 200px",
        maxWidth: "280px",
    },
    searchIcon: {
        position: "absolute",
        left: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#94a3b8",
        pointerEvents: "none",
        fontSize: "15px",
    },
    searchInput: {
        width: "100%",
        padding: "8px 12px 8px 4px",
        fontSize: "13px",
        border: "1px solid #e2e8f0",
        borderRadius: "8px",
        background: "#fff",
        color: "#0f172a",
        outline: "none",
        boxSizing: "border-box",
    },
    sortSelect: {
        fontSize: "13px",
        padding: "8px 10px",
        border: "1px solid #e2e8f0",
        borderRadius: "8px",
        background: "#fff",
        color: "#475569",
        cursor: "pointer",
    },
    viewBtnGroup: {
        display: "flex",
        border: "1px solid #e2e8f0",
        borderRadius: "8px",
        overflow: "hidden",
    },
    viewBtn: (active) => ({
        background: active ? "#eff6ff" : "#fff",
        color: active ? "#1d4ed8" : "#475569",
        border: "none",
        borderRight: "1px solid #e2e8f0",
        padding: "7px 11px",
        cursor: "pointer",
        fontSize: "15px",
        display: "flex",
        alignItems: "center",
    }),
    optBtn: {
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: "8px",
        padding: "8px 14px",
        fontSize: "13px",
        color: "#475569",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "6px",
    },
    addBtn: {
        background: "linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        padding: "9px 18px",
        fontSize: "13px",
        fontWeight: 700,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        whiteSpace: "nowrap",
    },
    metaText: {
        fontSize: "13px",
        color: "#64748b",
        marginBottom: "10px",
    },
    bulkBar: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        background: "#f1f5f9",
        borderRadius: "8px",
        border: "1px solid #e2e8f0",
        marginBottom: "10px",
        flexWrap: "wrap",
    },
    bulkCount: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#0f172a",
    },
    ghostBtn: {
        background: "transparent",
        border: "1px solid #e2e8f0",
        borderRadius: "6px",
        padding: "5px 12px",
        fontSize: "12px",
        color: "#475569",
        cursor: "pointer",
    },
    deleteBtn: {
        background: "#ef4444",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        padding: "5px 12px",
        fontSize: "12px",
        fontWeight: 500,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    },
    tableCard: {
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: "12px",
        overflow: "scroll",
        height: "60vh",
        margin: "18px 20px 22px",
    },
    tableWrap: {
        overflowX: "auto",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "13px",
        tableLayout: "auto",
    },
    thead: {
        background: "#f1f5f9",
        borderBottom: "1px solid #e2e8f0",
    },
    th: {
        padding: "15px 12px",
        textAlign: "left",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        color: "#ede9fb",
        whiteSpace: "nowrap",
    },
    td: {
        padding: "13px 12px",
        borderBottom: "1px solid #eef0f3",
        verticalAlign: "middle",
        color: "#1f2937",
        fontSize: "13px",
    },
    noImg: {
        width: "40px",
        height: "40px",
        borderRadius: "8px",
        background: "#f1f5f9",
        border: "1px solid #e2e8f0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "9px",
        color: "#94a3b8",
        fontWeight: 500,
    },
    productImg: {
        width: "40px",
        height: "40px",
        borderRadius: "8px",
        objectFit: "cover",
        border: "1px solid #e2e8f0",
    },
    channelBadge: (isShopify) => ({
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        background: isShopify ? "#f0fdf4" : "#eff6ff",
        border: `1px solid ${isShopify ? "#bbf7d0" : "#bfdbfe"}`,
        borderRadius: "6px",
        padding: "3px 8px",
        fontSize: "11px",
        color: isShopify ? "#15803d" : "#1d4ed8",
        fontWeight: 500,
    }),
    activePill: {
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: "999px",
        fontSize: "11px",
        fontWeight: 600,
        background: "#dcfce7",
        color: "#15803d",
    },
    disabledPill: {
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: "999px",
        fontSize: "11px",
        fontWeight: 600,
        background: "#fee2e2",
        color: "#b91c1c",
    },
    atcBtn: {
        background: "#16a34a",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        padding: "5px 10px",
        fontSize: "11px",
        fontWeight: 600,
        cursor: "pointer",
        whiteSpace: "nowrap",
    },
    moreBtn: {
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
        borderRadius: "6px",
        padding: "5px 7px",
        cursor: "pointer",
        color: "#475569",
        display: "inline-flex",
        alignItems: "center",
    },
    actionsCell: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
    },
    expandBtn: {
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#94a3b8",
        padding: "0 2px",
        fontSize: "13px",
    },
    pagination: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 24px",
        borderTop: "1px solid #eceef1",
        background: "#fbfbfc",
        flexWrap: "wrap",
        gap: "8px",
    },
    pgMeta: {
        fontSize: "13px",
        color: "#64748b",
    },
    pgBtns: {
        display: "flex",
        gap: "4px",
    },
    pgBtn: (active) => ({
        background: active ? "#1d4ed8" : "#fff",
        color: active ? "#fff" : "#374151",
        border: "1px solid #e2e8f0",
        borderRadius: "6px",
        padding: "5px 12px",
        fontSize: "13px",
        cursor: "pointer",
        fontWeight: active ? 600 : 400,
    }),
    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
    },
    modalTitle: {
        margin: 0,
        fontWeight: 700,
        fontSize: "17px",
        color: "#0f172a",
    },
    modalCloseBtn: {
        background: "#f1f5f9",
        border: "none",
        borderRadius: "8px",
        width: "32px",
        height: "32px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#475569",
    },
    syncRow: (disabled) => ({
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "11px 14px",
        borderRadius: "10px",
        background: "#f8fafc",
        marginBottom: "8px",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.45 : 1,
    }),
    mrpStrike: {
        textDecoration: "line-through",
        color: "#94a3b8",
        fontSize: "12px",
    },
    priceText: {
        fontWeight: 600,
        color: "#0f172a",
    },
};

export { S }